/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Channel_CheckinInputs */

const en_us2_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morning check-in`)
};

const pt_br2_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in da manhã`)
};

const es_419_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in de la mañana`)
};

const pt_pt2_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in da manhã`)
};

const fr_fr2_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan du matin`)
};

const de_de2_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen-Check-in`)
};

const it_it2_push_channel_checkin = /** @type {(inputs: Push_Channel_CheckinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in del mattino`)
};

/**
* | output |
* | --- |
* | "Morning check-in" |
*
* @param {Push_Channel_CheckinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_channel_checkin = /** @type {((inputs?: Push_Channel_CheckinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Channel_CheckinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_channel_checkin(inputs)
	if (locale === "es-419") return es_419_push_channel_checkin(inputs)
	if (locale === "pt-PT") return pt_pt2_push_channel_checkin(inputs)
	if (locale === "fr-FR") return fr_fr2_push_channel_checkin(inputs)
	if (locale === "de-DE") return de_de2_push_channel_checkin(inputs)
	if (locale === "it-IT") return it_it2_push_channel_checkin(inputs)
	return en_us2_push_channel_checkin(inputs)
});
export { push_channel_checkin as "push.channel_checkin" }